import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_MEMBER_CYCLE_PURCHASE_API,
	GET_CHECK_VALID_MEMBER_CYCLE_ORDER_API,
	GET_MEMBER_CYCLE_PURCHASE_HISTORY_API,
	GET_MEMBER_CYCLE_PURCHASE_FUTURE_API,
	GET_MEMBER_CYCLE_PURCHASE_TIMELINE_API,
} from "@apis/apiPath";

const useMemberCyclePurchaseApi = () => {
	const Ajax = useAjax();

	// 取得循環訂單列表 包含刪除跟退訂
	const getMemberCycleOrderApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_CYCLE_PURCHASE_API(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberCycleOrderCheckValidApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_CHECK_VALID_MEMBER_CYCLE_ORDER_API(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberCycleOrderHistoryApi = useCallback(
		async (memberID, cycleOrderID) => {
			const resp = await Ajax.get(GET_MEMBER_CYCLE_PURCHASE_HISTORY_API(memberID, cycleOrderID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberCycleOrderFutureApi = useCallback(
		async (memberID, cycleOrderID) => {
			const resp = await Ajax.get(GET_MEMBER_CYCLE_PURCHASE_FUTURE_API(memberID, cycleOrderID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberCycleOrderTimelineApi = useCallback(
		async (memberID, params) => {
			const resp = await Ajax.get(GET_MEMBER_CYCLE_PURCHASE_TIMELINE_API(memberID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getMemberCycleOrderApi,
		getMemberCycleOrderCheckValidApi,
		getMemberCycleOrderHistoryApi,
		getMemberCycleOrderFutureApi,
		getMemberCycleOrderTimelineApi,
	};
};

export default useMemberCyclePurchaseApi;
